// Angular 2
import "@angular/platform-browser";
import "@angular/platform-browser-dynamic";
import "@angular/core";
import "@angular/common";
import "@angular/common/http";
import "@angular/router";

// RxJS
import "rxjs";


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/vendor.ts